<template>
    <div style="padding-left: 35px; padding-right: 35px">
        <q-dialog position="right" v-model="dialog">
            <OrganizationDetail :currentPartner="currentPartner" :menu_id="menu_id" :org_id="org_id"
                                @closeDialog="dialog=false;menu_id=0"></OrganizationDetail>
        </q-dialog>

        <q-dialog persistent position="right" v-model="makeTransferDialog">
            <stock-transfer :to_orgId="selectedOrgId" :to_orgName="selectedOrgName"
                            :to_orgObj="selectedOrgObj"
                            @closeStockTransferDialog="selectedOrgObj='';makeTransferDialog=false" ref="stock-transfer">
            </stock-transfer>
        </q-dialog>

        <q-dialog persistent position="right" v-model="retailSalesDialog">
            <retail-sales @closeRetailSalesDialog="retailSalesDialog=false"></retail-sales>
        </q-dialog>


        <div class="position-absolute" style="right: 15px; top:70px; z-index: 1">
            <div class="d-flex">
                <div @click="addPartnerDialog=true" class="addButton d-flex">
                    <q-dialog persistent position="right" v-model="addPartnerDialog">
                        <CreatePartner @closeCreatePartnerDialog="addPartnerDialog=false"></CreatePartner>
                    </q-dialog>
                    <div class="add-button-text mx-auto my-auto">Add Partner</div>
                    <div class="add-button-icon mx-auto my-auto">
                        <i class="material-icons">
                            add
                        </i>
                    </div>
                </div>

                <!--<div @click="" class="export-button mr-3">-->
                <!--<div class="mt-1">-->
                <!--<img alt="" src="../assets/share.png">-->
                <!--</div>-->
                <!--&lt;!&ndash;Export&ndash;&gt;-->
                <!--</div>-->
                <div @click="transferStock()" class="export-button mr-3"
                     v-if="loggedIn_partnerType !== '921a8e09-766f-4894-b04c-495059858bb4'">
                    <q-tooltip>
                        Stock Transfer
                    </q-tooltip>
                    <div class="mt-1">
                        <img alt="" src="../assets/transfer.png">
                    </div>
                    <!--Export-->
                </div>
                <div @click="retailSales()" class="export-button mr-3">
                    <q-tooltip>
                        Retail Sales
                    </q-tooltip>
                    <div class="add-button-icon mx-auto my-auto" style="margin-right: 0px !important;">
                        <i class="material-icons">publish</i>
                    </div>
                </div>


                <q-input class="searchBox" debounce="300" placeholder="Search" style="width: 350px"
                         v-model="filter">
                    <template v-slot:prepend>
                        <q-icon name="search"/>
                    </template>
                </q-input>

            </div>
        </div>
        <!--partner count-->
        <!--        <p style="padding-top: 20px;">-->
        <!--            {{allApp.length}} Value Added Partners-->
        <!--        </p>-->





            <q-tabs align="left" class="text-primary" style="padding-left: 16px; padding-right: 16px;margin-top: 15px"
                    v-model="tab">
                <q-tab :label="'VAD ('+partnerCounts.VADArr+')'"  style="color:#5855d4" name="vad"
                                            v-if="loggedIn_partnerType===Constants.RD"></q-tab>
                <!-- chelsi -->
                <q-tab :label="'VP ('+partnerCounts.VPArr+')'" class="text-red" name="vp" v-if="loggedIn_partnerType!==Constants.VP"></q-tab>
                <q-tab :label="'VAP ('+partnerCounts.VAPArr+')'" class="text-orange" name="vap"></q-tab>
               
                <q-tab :label="'RP ('+partnerCounts.RPArr+')'" class="text-lime-10" name="rp"></q-tab>
            </q-tabs>
            <q-separator></q-separator>

            <q-table :columns="columns" :data="VADArr" :filter="filter" :pagination.sync="pagination_vad"
                     class="table-header" flat row-key="name" ref="VADArr"
                     table-class="table-class" v-show="tab==='vad'" v-if="loggedIn_partnerType===Constants.RD">
                <template v-slot:body="props">
                    <q-tr style="height: 5px"></q-tr>
                    <q-tr :props="props" @click.native="openDetailView(props.row)" class="tableItems">

                        <q-td :props="props" class="tItem" key="partnerCode">
                            <div :class="'partnerType ' + props.row.PartnerType.color" class="mt-2">
                                <div>
                                    <div class="type-button-icon">{{props.row.PartnerType.prefix}}</div>
                                    <!--                                            <div class="type-button-text">{{props.row.PartnerType.name}}</div>-->
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="ml-5">
                                    <span>{{props.row.partnerCode?'#'+props.row.partnerCode:'-'}}</span>
                                </div>
                            </div>
                        </q-td>
                        <q-td :props="props" class="tItem" key="name">
                            {{props.row.name}}
                        </q-td>
                        <q-td :props="props" class="tItem inventoryAction" key="Inventory"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{props.row.Inventory.aggregate?props.row.Inventory.aggregate.count:0}}</span>
                            <q-icon @click.stop="transferStock(props.row)" class="tItem mx-auto"
                                    name="sync_alt"></q-icon>
                        </q-td>
                        <q-td :props="props" class="tItem" key="SchemePoints"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{getSchemePoints(props.row.SchemePoints,props.row.PartnerType.specialSchemeId)}}</span>
                        </q-td>
                        <q-td :props="props" class="text-center" key="joinedSchemes">
                            <q-btn @click.stop="openDetailView_menuSchemes(props.row)" class="delete-btn"
                                   color="primary"
                                   flat
                                   round size="12px" small>
                                <q-icon><i class="fas fa-link" style="font-size: 15px"></i>
                                </q-icon>
                            </q-btn>
                        </q-td>
                        <q-td :props="props" class="tItem" key="userName">
                            {{props.row.Users && props.row.Users.length?props.row.Users[0].name:'-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="mobile">
                            {{props.row.mobile}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="email">
                            {{toLower(props.row.email)}}
                        </q-td>

                        <q-td :props="props" class="tItem" key="city">
                            {{props.row.address?capitalize(props.row.address.city): '-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="state">
                            {{props.row.address?capitalize(props.row.address.state): '-'}}
                        </q-td>

                        <q-td :props="props" key="SalesPersonId">
                        <span v-for="(sp,index) in props.row.SalesPersons">
                            {{sp.SalesPerson.name?sp.SalesPerson.name:'-'}}
                            <template v-if="index<props.row.SalesPersons.length-1">, </template>
                        </span>
                        </q-td>
                        <q-td :props="props" key="ParentPartner">
                            {{props.row.ParentPartner?props.row.ParentPartner.name:'-'}}
                        </q-td>
                        <q-td :props="props" key="PreferedVP">
                                    <span v-for="(distributor,index) in props.row.PreferredDistributors">
                                    {{distributor.PrefferedPartner?distributor.PrefferedPartner.name:''}}
                                    <template v-if="index<props.row.PreferredDistributors.length-1">, </template>
                                </span>
                        </q-td>
                        <q-td :props="props" class="tItem" key="createdOn">
                            {{props.row.createdOn | dateFilter}}
                            <q-btn class="list-options">
                                <i class="material-icons">
                                    more_vert
                                </i>
                            </q-btn>
                        </q-td>
                    </q-tr>
                </template>
            </q-table>

            <q-table :columns="columns" :data="VAPArr" :filter="filter" :pagination.sync="pagination_vap"
                     class="table-header" flat row-key="name" ref="VAPArr"
                     table-class="table-class" v-show="tab==='vap'">
                <template v-slot:body="props">
                    <q-tr style="height: 5px"></q-tr>
                    <q-tr :props="props" @click.native="openDetailView(props.row)" class="tableItems">

                        <q-td :props="props" class="tItem" key="partnerCode">
                            <div :class="'partnerType ' + props.row.PartnerType.color" class="mt-2" style="">
                                <div>
                                    <div class="type-button-icon">{{props.row.PartnerType.prefix}}</div>
                                    <!--                                            <div class="type-button-text">{{props.row.PartnerType.name}}</div>-->
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="ml-5">
                                    <span>{{props.row.partnerCode?'#'+props.row.partnerCode:'-'}}</span>
                                </div>
                            </div>
                        </q-td>
                        <!--<q-td :props="props" class="tItem" key="partnerType">-->
                        <!--{{props.row.PartnerType.name}}-->
                        <!--</q-td>-->
                        <q-td :props="props" class="tItem" key="name">
                            {{props.row.name}}
                        </q-td>
                        <q-td :props="props" class="tItem inventoryAction" key="Inventory"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{props.row.Inventory.aggregate?props.row.Inventory.aggregate.count:0}}</span>
                            <q-icon @click.stop="transferStock(props.row)" class="tItem mx-auto"
                                    name="sync_alt"></q-icon>
                        </q-td>
                        <q-td :props="props" class="tItem" key="SchemePoints"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{getSchemePoints(props.row.SchemePoints,props.row.PartnerType.specialSchemeId)}}</span>
                        </q-td>
                        <q-td :props="props" class="text-center" key="joinedSchemes">
                            <q-btn @click.stop="openDetailView_menuSchemes(props.row)" class="delete-btn"
                                   color="primary"
                                   flat
                                   round size="12px" small>
                                <q-icon><i class="fas fa-link" style="font-size: 15px"></i>
                                </q-icon>
                            </q-btn>
                        </q-td>
                        <q-td :props="props" class="tItem" key="userName">
                            {{props.row.Users && props.row.Users.length?props.row.Users[0].name:'-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="mobile">
                            {{props.row.mobile}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="email">
                            {{toLower(props.row.email)}}
                        </q-td>

                        <q-td :props="props" class="tItem" key="city">
                            {{props.row.address?capitalize(props.row.address.city): '-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="state">
                            {{props.row.address?capitalize(props.row.address.state): '-'}}
                        </q-td>

                        <q-td :props="props" key="SalesPersonId">
                        <span v-for="(sp,index) in props.row.SalesPersons">
                            {{sp.SalesPerson.name?sp.SalesPerson.name:'-'}}
                            <template v-if="index<props.row.SalesPersons.length-1">, </template>
                        </span>
                        </q-td>
                        <q-td :props="props" key="ParentPartner">
                            {{props.row.ParentPartner?props.row.ParentPartner.name:'-'}}
                        </q-td>
                        <q-td :props="props" key="PreferedVP">
                                    <span v-for="(distributor,index) in props.row.PreferredDistributors">
                                    {{distributor.PrefferedPartner?distributor.PrefferedPartner.name:''}}
                                    <template v-if="index<props.row.PreferredDistributors.length-1">, </template>
                                </span>
                        </q-td>

                        <q-td :props="props" class="tItem" key="createdOn">
                            {{props.row.createdOn | dateFilter}}
                            <q-btn class="list-options">
                                <i class="material-icons">
                                    more_vert
                                </i>
                            </q-btn>
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
            <!-- chelsi -->
 <q-table :columns="columns" :data="VPArr" :filter="filter" :pagination.sync="pagination_vp"
                     class="table-header" flat row-key="name" ref="VPArr"
                     table-class="table-class" v-show="tab==='vp'">
                <template v-slot:body="props">
                    <q-tr style="height: 5px"></q-tr>
                    <q-tr :props="props" @click.native="openDetailView(props.row)" class="tableItems">

                        <q-td :props="props" class="tItem" key="partnerCode">
                            <!-- :class="'partnerType ' + props.row.PartnerType.color" -->
                            <div  class="mt-2" style="width: 40px;
  height: 40px;
  background: red;
  color: #fff;
  position: absolute;
  left: 0;
  overflow: hidden;
  top: 0;
  text-align: center;
  line-height: 40px;
  border-radius: 50px;
  transition: 0.3s;"">
                                <div>
                                    <div class="type-button-icon">{{props.row.PartnerType.prefix}}</div>
                                    <!--                                            <div class="type-button-text">{{props.row.PartnerType.name}}</div>-->
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="ml-5">
                                    <span>{{props.row.partnerCode?'#'+props.row.partnerCode:'-'}}</span>
                                </div>
                            </div>
                        </q-td>
                        <!--<q-td :props="props" class="tItem" key="partnerType">-->
                        <!--{{props.row.PartnerType.name}}-->
                        <!--</q-td>-->
                        <q-td :props="props" class="tItem" key="name">
                            {{props.row.name}}
                        </q-td>
                        <q-td :props="props" class="tItem inventoryAction" key="Inventory"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{props.row.Inventory.aggregate?props.row.Inventory.aggregate.count:0}}</span>
                            <q-icon @click.stop="transferStock(props.row)" class="tItem mx-auto"
                                    name="sync_alt"></q-icon>
                        </q-td>
                        <q-td :props="props" class="tItem" key="SchemePoints"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{getSchemePoints(props.row.SchemePoints,props.row.PartnerType.specialSchemeId)}}</span>
                        </q-td>
                        <q-td :props="props" class="text-center" key="joinedSchemes">
                            <q-btn @click.stop="openDetailView_menuSchemes(props.row)" class="delete-btn"
                                   color="primary"
                                   flat
                                   round size="12px" small>
                                <q-icon><i class="fas fa-link" style="font-size: 15px"></i>
                                </q-icon>
                            </q-btn>
                        </q-td>
                        <q-td :props="props" class="tItem" key="userName">
                            {{props.row.Users && props.row.Users.length?props.row.Users[0].name:'-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="mobile">
                            {{props.row.mobile}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="email">
                            {{toLower(props.row.email)}}
                        </q-td>

                        <q-td :props="props" class="tItem" key="city">
                            {{props.row.address?capitalize(props.row.address.city): '-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="state">
                            {{props.row.address?capitalize(props.row.address.state): '-'}}
                        </q-td>

                        <q-td :props="props" key="SalesPersonId">
                        <span v-for="(sp,index) in props.row.SalesPersons">
                            {{sp.SalesPerson.name?sp.SalesPerson.name:'-'}}
                            <template v-if="index<props.row.SalesPersons.length-1">, </template>
                        </span>
                        </q-td>
                        <q-td :props="props" key="ParentPartner">
                            {{props.row.ParentPartner?props.row.ParentPartner.name:'-'}}
                        </q-td>
                        <q-td :props="props" key="PreferedVP">
                                    <span v-for="(distributor,index) in props.row.PreferredDistributors">
                                    {{distributor.PrefferedPartner?distributor.PrefferedPartner.name:''}}
                                    <template v-if="index<props.row.PreferredDistributors.length-1">, </template>
                                </span>
                        </q-td>

                        <q-td :props="props" class="tItem" key="createdOn">
                            {{props.row.createdOn | dateFilter}}
                            <q-btn class="list-options">
                                <i class="material-icons">
                                    more_vert
                                </i>
                            </q-btn>
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
            <q-table :columns="columns" :data="RPArr" :filter="filter" :pagination.sync="pagination_rp"
                     class="table-header" flat row-key="name" ref="RPArr"
                     table-class="table-class" v-show="tab==='rp'">
                <template v-slot:body="props">
                    <q-tr style="height: 5px"></q-tr>
                    <q-tr :props="props" @click.native="openDetailView(props.row)" class="tableItems">

                        <q-td :props="props" class="tItem" key="partnerCode">
                            <div :class="'partnerType ' + 'bg-'+props.row.PartnerType.color" class="mt-2">
                                <div>
                                    <div class="type-button-icon">{{props.row.PartnerType.prefix}}</div>
                                    <!--                                            <div class="type-button-text">{{props.row.PartnerType.name}}</div>-->
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="ml-5">
                                    <span>{{props.row.partnerCode?'#'+props.row.partnerCode:'-'}}</span>
                                </div>
                            </div>
                        </q-td>
                        <!--<q-td :props="props" class="tItem" key="partnerType">-->
                        <!--{{props.row.PartnerType.name}}-->
                        <!--</q-td>-->
                        <q-td :props="props" class="tItem" key="name">
                            {{props.row.name}}
                        </q-td>
                        <q-td :props="props" class="tItem inventoryAction" key="Inventory"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{props.row.Inventory.aggregate?props.row.Inventory.aggregate.count:0}}</span>
                            <q-icon @click.stop="transferStock(props.row)" class="tItem mx-auto"
                                    name="sync_alt"></q-icon>
                        </q-td>
                        <q-td :props="props" class="tItem" key="SchemePoints"
                              style="text-align: center; color: #2d2d2d;">
                            <span style="font-weight: 600; font-size: 18px">{{getSchemePoints(props.row.SchemePoints,props.row.PartnerType.specialSchemeId)}}</span>
                        </q-td>
                        <q-td :props="props" class="text-center" key="joinedSchemes">
                            <q-btn @click.stop="openDetailView_menuSchemes(props.row)" class="delete-btn"
                                   color="primary"
                                   flat
                                   round size="12px" small>
                                <q-icon><i class="fas fa-link" style="font-size: 15px"></i>
                                </q-icon>
                            </q-btn>
                        </q-td>
                        <q-td :props="props" class="tItem" key="userName">
                            {{props.row.Users && props.row.Users.length?props.row.Users[0].name:'-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="mobile">
                            {{props.row.mobile}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="email">
                            {{toLower(props.row.email)}}
                        </q-td>

                        <q-td :props="props" class="tItem" key="city">
                            {{props.row.address?capitalize(props.row.address.city): '-'}}
                        </q-td>
                        <q-td :props="props" class="tItem" key="state">
                            {{props.row.address?capitalize(props.row.address.state): '-'}}
                        </q-td>

                        <q-td :props="props" key="SalesPersonId">
                        <span v-for="(sp,index) in props.row.SalesPersons">
                            {{sp.SalesPerson.name?sp.SalesPerson.name:'-'}}
                            <template v-if="index<props.row.SalesPersons.length-1">, </template>
                        </span>
                        </q-td>
                        <q-td :props="props" key="ParentPartner">
                            {{props.row.ParentPartner?props.row.ParentPartner.name:'-'}}
                        </q-td>
                        <q-td :props="props" key="PreferedVP">
                                    <span v-for="(distributor,index) in props.row.PreferredDistributors">
                                    {{distributor.PrefferedPartner?distributor.PrefferedPartner.name:''}}
                                    <template v-if="index<props.row.PreferredDistributors.length-1">, </template>
                                </span>
                        </q-td>

                        <q-td :props="props" class="tItem" key="createdOn">
                            {{props.row.createdOn | dateFilter}}
                            <q-btn class="list-options">
                                <i class="material-icons">
                                    more_vert
                                </i>
                            </q-btn>
                        </q-td>
                    </q-tr>
                </template>
            </q-table>

        <!--   -------------------Common q-inner-loader when content loading for any table ------------- -->
        <div v-show="application_loading">
            <q-inner-loading :showing="true" style="top: 183px">
                <q-spinner-dots size="50px" style="color: #027be3"/>
            </q-inner-loading>
        </div>
        <!--   ----------------x-------------x-------------x--------------------x-------------x---------- -->


    </div>
</template>

<script>
  import { GET_ALL_ORGANIZATION } from '../graphql/queries/organization'
  import { SUBSCRIBE_ALL_ORGANIZATION } from '../graphql/subscription/organization'
  import OrganizationDetail from './Organization/OrganizationDetail'
  import CreatePartner from './CreatePartner'
  import StockTransfer from './StockTransfer'
  import RetailSales from './RetailSales'
  import moment from 'moment'
  import Constants from '../Constants/Constant'

  export default {
    name: 'Partners',
    components: { OrganizationDetail, CreatePartner, StockTransfer, RetailSales },
    apollo: {},
    data () {
      return {
        Constants: Constants,
        dialog: false,
        loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
        tab: JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.RD?'vad':'vap',
        allApp: [],
        VADArr: [],
        VAPArr: [],
        VPArr: [],
        RPArr: [],
        pagination_allApp: { rowsPerPage: 30 },
        pagination_vad: { rowsPerPage: 30 },
        pagination_vap: { rowsPerPage: 30 },
        pagination_vp: { rowsPerPage: 30 },
        pagination_rp: { rowsPerPage: 30 },
        filter: '', org_id: '245eeacc-ceb2-4108-b281-1ce86a12cf02',
        columns: [
          // { name: 'partnerType', label: 'Type', field: 'partnerType', align: 'left', sortable: true },
          { name: 'partnerCode', label: 'Partner Code', field: 'partnerCode', align: 'left', sortable: true },
          { name: 'name', label: 'Company Name', field: 'name', align: 'left', sortable: true },
          { name: 'Inventory', label: 'Inventory',
            field: row => row.Inventory.aggregate ? row.Inventory.aggregate.count : 0,
            align: 'left', sortable: true
          },
         /* { name: 'SchemePoints', label: 'Earn/Eligible Points', field: 'SchemePoints', align: 'left', sortable: true }, */
          { name: 'joinedSchemes', label: 'Joined Schemes', field: 'joinedSchemes', align: 'left' },
          { name: 'userName', label: 'Partner Name',
            field: row => row.Users && row.Users.length ? row.Users[0].name : '',
            align: 'left', sortable: true
          },
          { name: 'mobile', label: 'Mobile', field: 'mobile', align: 'left', sortable: true },
          { name: 'email', label: 'Email', field: 'email', align: 'left', sortable: true },
          { name: 'city', label: 'City', field: row => row.address.city, align: 'left', sortable: true },
          { name: 'state', label: 'State', field: row => row.address.state, align: 'left', sortable: true },
          { name: 'gstin', label: 'GSTIN', field: 'gstin', align: 'left', sortable: true, style: 'display:none' },
          { name: 'aadhaarNumber', label: 'Aadhaar', field: 'aadhaarNumber', align: 'left', sortable: true, style: 'display:none' },
          { name: 'PAN', label: 'PAN', field: 'PAN', align: 'left', sortable: true, style: 'display:none' },
          {
            name: 'SalesPersonId',
            label: 'Amity Sales Executive',
            field: function (row) {
                var str = ''
                if (!row.SalesPersons) {return}
                row.SalesPersons.forEach(function(curnt){
                    if(curnt&&curnt.SalesPerson){
                        str = str + curnt.SalesPerson.name
                    }
                })
                return str
            },
            align: 'left',
            sortable: true,
          },
          { name: 'ParentPartner', label: 'Refferal VAP', field: row => row.ParentPartner ? row.ParentPartner.name : '',
            align: 'left', sortable: true },
          {
            name: 'PreferedVP',
            label: 'Preferred Distributor for Purchase',
            field: function (row) {
                var str = ''
                if (!row.PreferredDistributors) {return}
                row.PreferredDistributors.forEach(function(curnt){
                    if(curnt&&curnt.PrefferedPartner){
                        str = str + curnt.PrefferedPartner.name
                    }
                })
                return str
            },
            align: 'left',
            sortable: true,
          },
          // { name: 'partnerCode', label: 'Partner Code', field: 'partnerCode', align: 'left', sortable: true },
          { name: 'createdOn', label: 'Registration Date', field: 'createdOn', align: 'left', sortable: true },

          // { name: 'action', label: 'Action', field: 'action', align: 'left' },
        ],
        addPartnerDialog: false,
        makeTransferDialog: false,
        retailSalesDialog: false,
        selectedOrgId: '',
        selectedOrgName: '',
        selectedOrgObj: '',
        currentPartner: null,
        menu_id: null,
        application_loading: true,
        partnerCounts: JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.RD ?
            {'VADArr': 0, 'VAPArr': 0, 'RPArr': 0,'VPArr':0,}:{'VAPArr': 0, 'RPArr': 0, 'VPArr':0,}
      }
    },
    mounted () {
      this.tab = this.$route.query && this.$route.query.where ? this.$route.query.where : this.tab
      setTimeout(() => {
        this.fetchOrganizations()
      }, 400)
    },
    watch:{
        'filter' () {
            setTimeout( () => {
                Object.keys(this.partnerCounts).forEach(type => {
                    this.partnerCounts[type] = this.$refs[type].computedRowsNumber
                })
            }, 100)
        },
    },
    filters: {
      dateFilter (val) {
        return val ? moment(val).format('DD/MM/YYYY') : '-'
        // let diff=moment().diff(moment(val), 'days')
        // if(diff>0)
        //   return val ? moment().diff(moment(val), 'days')  + ' days' : '-'
        // else return val ? 'Today' : '-'
      },
      nameSplitter (val) {
        let split = val.split(' ')
        return split[0][0] + split[1][0]
      },
    },
    methods: {
      capitalize (string) {
        return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : '-'
      },
      openDetailView_menuSchemes (row) {
        this.org_id = row.id
        this.currentPartner = row             //passed to props
        this.menu_id = 8                      // menuId of schemes sub-menu
        this.dialog = true
      },
      async fetchOrganizations () {
        let self = this
        let response = await this.$apollo.query({
          query: GET_ALL_ORGANIZATION,
          fetchPolicy: 'network-only',
          variables: {
            // partnerType: not in VAD, RD and NP(for VAD loggedIn) & not in RD and NP(for RD loggedIn)
            prefferedVP: JSON.parse(localStorage.getItem('user')).orgId,
            partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType ===
            '3260ebcf-8944-4dc1-a003-9997b0e07811' ?
              [
                '3260ebcf-8944-4dc1-a003-9997b0e07811',
                '917370fd-9532-4f84-bd30-9b6f0777e206',
                '9260ebcf-8944-4dc1-a003-9997b0e07811'] :
              ['917370fd-9532-4f84-bd30-9b6f0777e206', '9260ebcf-8944-4dc1-a003-9997b0e07811'],
          },
        })
        if (response.data) {
          this.allApp = response.data.Organizations
          this.separateOrganizationOnType(response.data.Organizations)

        }
        const observer = this.$apollo.subscribe({
          query: SUBSCRIBE_ALL_ORGANIZATION,
          variables: {
            // partnerType: not in VAD, RD and NP(for VAD loggedIn) & not in RD and NP(for RD loggedIn)
            prefferedVP: JSON.parse(localStorage.getItem('user')).orgId,
            partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType ===
            '3260ebcf-8944-4dc1-a003-9997b0e07811' ?
              [
                '3260ebcf-8944-4dc1-a003-9997b0e07811',
                '917370fd-9532-4f84-bd30-9b6f0777e206',
                '9260ebcf-8944-4dc1-a003-9997b0e07811'] :
              ['917370fd-9532-4f84-bd30-9b6f0777e206', '9260ebcf-8944-4dc1-a003-9997b0e07811'],
          },
        })

        observer.subscribe({
          next (response) {
            self.allApp = response.data.Organizations
            self.separateOrganizationOnType(response.data.Organizations)
          },
          error (error) {
            console.error(error)
          },
        })
      },
    //   chelsi
      separateOrganizationOnType (data) {
        let self = this
        this.VADArr = []
        this.VAPArr = []
        this.VPArr = []
        this.RPArr = []
        data.forEach(app => {
          if (app.partnerType === Constants.VAP)
            self.VAPArr.push(app)
          else if (app.partnerType === Constants.VP)
            self.VPArr.push(app)
          else if (app.partnerType === Constants.RP)
            self.RPArr.push(app)
          else if (app.partnerType === Constants.VAD)
            self.VADArr.push(app)
        })
          Object.keys(this.partnerCounts).forEach(type => {
              this.partnerCounts[type] = this[type].length
          })

       this.application_loading = false
      },
      searchSerial (val, update, abort) {
        let splitted = val.split(' ')
        if (splitted.length <= 1) {
          if (val.length < 1) {
            abort()
            return
          }
          update(() => {
            this.serialFilter = '%' + val + '%'
          })
        } else {

        }
      },
      getColor (val) {
        if (val === 'Volume Partner')
          return 'warning'
        else if (val === 'Normal Partner')
          return 'purple'
        else if (val === 'Loyal Partner')
          return 'orange'
        else if (val === 'Sub Stockist')
          return 'success'
      },
      openDetailView (row) {
        this.currentPartner = row
        this.org_id = row.id
        this.dialog = true
      },
      transferStock (orgObj) {
        if (orgObj) {
          this.selectedOrgId = orgObj.id
          this.selectedOrgName = orgObj.name
        }
        this.selectedOrgObj = orgObj
        this.makeTransferDialog = true
      },
      retailSales () {
        this.retailSalesDialog = true
      },
    },
  }
</script>
<style lang="stylus">
    .table-header
        /* max height is important */

        .q-table__middle
            max-height 600px

        .q-table__top,
        .q-table__bottom,
        thead tr:first-child th /* bg color is important for th; just specify one */
            background-color #ffffff

        thead tr:first-child th
            position sticky
            top 0
            opacity 1
            z-index 1
</style>
